import React from "react";
import Iconfont from "../../components/Iconfont/Iconfont";
import {getSearchParams, responseDataFilter} from "../../utils/tool";
import API from "../../api";
import "./index.scss";

class Read extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: window.screen.width < 500,
            isIphone: /iPhone|iPod/i.test(navigator.userAgent),
            bookInfo: {},
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        this.getBookInfoFunc();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({
            isMobile: document.documentElement.clientWidth < 500,
        });
    }

    async getBookInfoFunc () {
        const {bookId} = getSearchParams();
        const res = await API.Book.getBookInfo({
            data: {bookId: bookId},
        });

        const resData = responseDataFilter(res);
        if (resData) {
            this.setState({
                bookInfo: resData,
            });
        }
    }

    downLoadApp () {
        const {bookInfo, isIphone} = this.state;
        const url = isIphone ? bookInfo.appleUrl : bookInfo.androidUrl;
        if (url) {
        let aDom = document.createElement("a");
            aDom.href = url;
            aDom.download = bookInfo.platformName;
            aDom.click();
        }
    }

    backFunc () {
        if (window.historyInstance) {
            window.historyInstance.replace("/page/book-list");
        }
    }

    render() {
        const {bookInfo, isMobile} = this.state;

        return (
            <div className={`readFrame ${isMobile ? "mobileStatus" : ""}`}>
                <div className="readHeadBox">
                    <span className="bookName overflowEllipsis">{bookInfo.bookName}</span>
                    <div className="maskBox"></div>
                    {
                        isMobile ? (<span className="backBtn" onClick={() => this.backFunc()}><Iconfont type={"icon-back"} /></span>) : undefined
                    }
                </div>

                <div className="readContentList">
                    <div className="scrollBox">
                        {bookInfo?.contentList?.map((item, index) => <div key={index} className="readContentItem">{item}</div>)}
                        <div className="maskBox"></div>
                        <div className="downBtn" onClick={() => this.downLoadApp()}>
                            <span className="btnName">
                                {bookInfo.tip}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Read;
